import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSubscription,
  BackendMutationStartCustomerSubscriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation StartCustomerSubscription(
    $customerId: ID!
    $plan: String!
    $wordsTier: String
    $stripePaymentMethodId: ID!
    $promotionCode: String
    $billingCycle: BillingCyclePeriod
  ) {
    startCustomerSubscription(
      customerId: $customerId
      plan: $plan
      wordsTier: $wordsTier
      stripePaymentMethodId: $stripePaymentMethodId
      promotionCode: $promotionCode
      billingCycle: $billingCycle
    ) {
      status
      latestInvoice {
        paymentIntentStatus
        paymentIntentClientSecret
      }
      customer {
        stripeCustomerId
      }
    }
  }
`;

type Variables = Omit<BackendMutationStartCustomerSubscriptionArgs, 'wordsTier'> & {
  tier?: BackendMutationStartCustomerSubscriptionArgs['wordsTier'];
};
type Result = Pick<BackendCustomerSubscription, 'status' | 'latestInvoice' | 'customer'>;

export const startCustomerSubscription = async ({
  customerId,
  plan,
  tier,
  stripePaymentMethodId,
  promotionCode,
  billingCycle,
}: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      plan,
      wordsTier: tier,
      stripePaymentMethodId,
      promotionCode,
      billingCycle,
    },
  });
  return getSingleProp<Result>(result.data);
};
